import { render, staticRenderFns } from "./AddressBookAutocompleteItem.vue?vue&type=template&id=851802de&"
import script from "./AddressBookAutocompleteItem.vue?vue&type=script&lang=ts&"
export * from "./AddressBookAutocompleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports